import React, { useContext, useEffect } from 'react'
import { FaCartPlus, FaHome, FaPhoneAlt, FaSearch} from 'react-icons/fa'
import { Link, NavLink } from 'react-router-dom';
import { RootContext } from '../../store/context/rootContext';
import { auth } from '../../db/auth';
import Logo from './khb-logo.png';

export default function Header() {
    const { cart, saveUser } = useContext(RootContext);

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(userAuth => {
            saveUser(userAuth);
        })
        return unsubscribe;
        // eslint-disable-next-line
    }, [])

    const getStyle = (isActive) => {
        return {
            color: isActive ? "#f1c78d" : "#f7fbfd",
            cursor: "pointer"
        };
    }

    const getMobileStyle = (isActive) => {
        return {
            color: isActive ? "#7f2912" : "#495057",
            cursor: "pointer"
        }
    }



    return (
        <nav className="navbar fixed-top navbar-expand-lg navbar-light" style={{ background: "#7f2912" }} >
            <div className="container-fluid">
                <Link className="navbar-brand" to="/" style={{ color: "#effbff" }}>
                    {/* <FaHome size='2rem' className='mx-2' /> */}
                    <h1 style={{ fontSize: "1.5rem", margin: "0px" }}>
                        <img src={Logo} className='mx-2 rounded' width={45} height={30} alt='logo' />
                        Khanakul Bazaar
                    </h1>
                </Link>

                <div className="collapse d-sm-inline ">
                    <ul className="d-flex flex-row navbar-nav justify-content-between" >
                        <li className="nav-item mx-2">
                            <NavLink className="nav-link" style={({ isActive }) => getStyle(isActive)} aria-current="page" to="/">
                                <FaHome /> Home
                            </NavLink>
                        </li>

                        <li className="nav-item mx-2">
                            <NavLink className="nav-link" style={({ isActive }) => getStyle(isActive)} to="/contact">
                                <FaPhoneAlt /> Contact
                            </NavLink>
                        </li>
                        {cart && cart.length > 0 && <li className="nav-item mx-2">
                            <NavLink className="nav-link" style={({ isActive }) => getStyle(isActive)} to="/cart">
                                <FaCartPlus /> Cart [{cart.length}]
                            </NavLink>
                        </li>}
                        <li className="nav-item mx-2">
                            <NavLink className="nav-link" style={({ isActive }) => getStyle(isActive)} to="/findOrder">
                            <FaSearch /> Find Order
                            </NavLink>
                        </li>
                    </ul>
                </div>
                <div className='d-sm-none'>
                    {cart && cart.length > 0 && <NavLink className="nav-link d-inline-block position-relative me-2" style={({ isActive }) => getStyle(isActive)} to='/cart' >
                        <FaCartPlus size={"1.5rem"} />
                            <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                {cart.length}
                            </span>
                    </NavLink>}
                </div>

                {/* mobile screen */}
                <div className='row row-col-4 w-100 position-fixed bottom-0  bg-white border text-center d-sm-none'>

                    <div className='col p-1 '>
                        <NavLink to="/" style={({ isActive }) => getMobileStyle(isActive)}><FaHome /><br />Home</NavLink>
                    </div>

                    <div className="col border-3 border-start p-1">
                        <NavLink to="/contact" style={({ isActive }) => getMobileStyle(isActive)}><FaPhoneAlt /><br />contact</NavLink>
                    </div>
                    <div className="col border-3 border-start p-1">
                    <NavLink className="nav-link" style={({ isActive }) => getMobileStyle(isActive)}
                            to="/findOrder">
                            <FaSearch /><br /> Find Order
                        </NavLink>
                    </div>
                </div>
            </div>
        </nav >
    )
}
